import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import LoadingComponent from 'components/generic/LoadingComponent'
import { learningPathsStatus } from 'reduxModules/learningPaths'
import { learningPathsStateSelector as stateSelector } from 'reduxModules/learningPaths/selectors'
import { learningPathsDispatchers as stateDispatcher } from 'reduxModules/learningPaths/dispatchers'
import LearningPath, { LearningPathSummaryPropTypes } from '../LearningPathSummary'
import BannerSlideShow from '../../generic/BannerSlideShow'
import './styles.css'

export class LearningPathList extends Component {
  componentDidMount() {
    const { getLearningPaths, loadBanners } = this.props
    getLearningPaths()
    loadBanners()
  }

  componentWillUnmount() {
    this.props.clearLearningPathList()
  }

  render() {
    const { learningPaths, status, banners, isMobile } = this.props

    if (!learningPaths || status !== learningPathsStatus.success)
      return <LoadingComponent />

    return (
      <article id="LearningPathList">
        <Helmet>
          <title>
            Learning Pathways | Stan Winston School of Character Arts
          </title>
          <meta
            name="description"
            content="Follow guided learning pathways through special-effects and character-creation disciplines — structured curricula from beginner to advanced at Stan Winston School."
          />
        </Helmet>
        {banners && (
          <BannerSlideShow
            banners={banners}
            isMobile={isMobile}
          />
        )}
        <section className="heading wrapper">
          <h1>Learning Pathways</h1>
        </section>
        <div className="content-list wrapper">
          {learningPaths.map((path) => (
            <LearningPath
              key={path.id}
              className="content-list__item"
              {...path}
            />
          ))}
        </div>
      </article>
    )
  }
}

LearningPathList.propTypes = {
  learningPaths: PropTypes.arrayOf(
    PropTypes.shape(LearningPathSummaryPropTypes)
  ),
  getLearningPaths: PropTypes.func,
  loadBanners: PropTypes.func,
  clearLearningPathList: PropTypes.func,
  status: PropTypes.string,
  banners: PropTypes.array,
  isMobile: PropTypes.bool
}

LearningPathList.defaultProps = {
  learningPaths: [],
  getLearningPaths: () => {},
  loadBanners: () => {},
  clearLearningPathList: () => {},
  status: '',
  banners: null,
  isMobile: false
}

export default connect(stateSelector, stateDispatcher)(LearningPathList)
